/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const SupplierRole = zod.enum([
  "MANUFACTURER",
  "WORKSHOP",
  "DISTRIBUTOR",
  "SERVICE_PROVIDER",
]);

export type SupplierRole = zod.input<typeof SupplierRole>;
export type SupplierRoleOutput = zod.output<typeof SupplierRole>;
